import SvgBitcartLogo from "./icons/bitcart-logo.js";
import { BitcartWordmarkIcon } from "./icons/bitcart-wordmark2.js";
// src/icons/index.ts
const BitcartLogoIcon = SvgBitcartLogo;
export { BitcartLogoIcon, BitcartWordmarkIcon };

//# sourceMappingURL=icons.js.map